import React from "react";
import styled from "@emotion/styled";
import { BaseMenuItem } from "./styles";
import { spacing } from "@atlas-int/tokens";

const FindInVizMenuItem = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  margin-bottom: ${spacing[1]};
  && * {
    text-transform: none; // To unset capitalization style of parent container
  }
`;

const LabelContainer = styled.div`
  flex: 1;
  min-width: 0;
  padding-left: ${spacing[4]};
  padding-right: ${spacing[2]};
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

interface FindInVizDropdownItemInput {
  item: { id: string; label: string };
  hashFunction: (item: { id: string }) => string;
  getItemProps: (options: { item: { id: string; label: string }; index: number }) => Record<string, unknown> & { onClick?: (e: React.MouseEvent) => void };
  mappedItemIndex: number;
  index: number;
  highlightedIndex: number;
  selectedItem: { id: string } | null;
}

const FindInVizDropdownItem = ({
  item,
  selectedItem,
  highlightedIndex,
  mappedItemIndex,
  getItemProps,
}: FindInVizDropdownItemInput) => {
  const { label } = item;
  const itemProps = getItemProps({ item, index: mappedItemIndex });

  return (
    <BaseMenuItem
      className={[
        mappedItemIndex === highlightedIndex ? "menu-item--highlighted" : "",
        selectedItem && item.id === selectedItem.id ? "menu-item--selected" : "",
      ].join(" ").trim()}
      key={`item_${item.id}`}
      {...itemProps}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        if (itemProps.onClick) {
          itemProps.onClick(e);
        }
      }}
    >
      <FindInVizMenuItem>
        <LabelContainer>{label}</LabelContainer>
      </FindInVizMenuItem>
    </BaseMenuItem>
  );
};

export default FindInVizDropdownItem;
